import Area, { IArea } from "../../core/areas/Area";
import Application from "../../Application";
import { IRouter } from "../../runtime/Router";
import SearchResultsPage from "../ui/pages/SearchResultsPage";
import SearchService from "../service/SearchService";
import RunSimpleSearchQueryInteractor from "../interactor/RunSimpleSearchQueryInteractor";
import ShowSearchResultsInteractor from "../interactor/ShowSearchResultsInteractor";
import { Layouts } from "../../core/common/Constants";
import AdvancedSearchCriteriaPage from "../ui/pages/AdvancedSearchCriteriaPage";
import ShowAdvancedSearchCriteriaInteractor from "../interactor/ShowAdvancedSearchCriteriaInteractor";
import RunSearchQueryInteractor from "../interactor/RunSearchQueryInteractor";

export default class SearchArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;
    container.registerFunction("searchService", SearchService);
    container.registerInteractor(
      "showAdvancedSearchCriteria",
      ShowAdvancedSearchCriteriaInteractor
    );
    container.registerInteractor(
      "showSearchResults",
      ShowSearchResultsInteractor
    );
    container.registerInteractor(
      "runSimpleSearchQuery",
      RunSimpleSearchQueryInteractor
    );
    container.registerInteractor("runSearchQuery", RunSearchQueryInteractor);
  }

  register(params: any) {
    this.registerModules();

    this.router.registerRoutes(
      this.application.isPortal()
        ? {
            path: "/search",
            page: this.createPage({
              Page: SearchResultsPage,
              action: this.showSearchResultsPage.bind(this)
            }),
            options: {
              secure: false,
              layout: Layouts.PORTAL
            }
          }
        : {
            path: "/search",
            page: this.createPage({
              Page: SearchResultsPage,
              action: this.showSearchResultsPage.bind(this)
            }),
            options: {
              secure: true
            }
          },
      {
        path: "/advanced-search",
        page: this.createPage({
          Page: AdvancedSearchCriteriaPage,
          action: this.showAdvancedSearchCriteriaPage.bind(this)
        }),
        options: {
          secure: true
        }
      }
    );
  }

  public showSearchResultsPage(params) {
    if (params.page) {
      params.page = Number.parseInt(params.page, 10);
    }
    if (params.pageSize) {
      params.pageSize = Number.parseInt(params.pageSize, 10);
    }
    return this.application.container

      .resolve<ShowSearchResultsInteractor>("showSearchResults")
      .execute(params);
  }

  public showAdvancedSearchCriteriaPage(params) {
    return this.application.container
      .resolve<ShowAdvancedSearchCriteriaInteractor>(
        "showAdvancedSearchCriteria"
      )
      .execute(params);
  }
}
